/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import TagRequirements from './requirements/container/RequirementsTagging';
import TempRequirementsTagging from './requirements/container/TempRequirementsTagging';
import OrdinanceRevisionContainer from './ordinanceRevision/container/OrdinanceRevisionContainer';
import TaxAmnestyContainer from './taxAmnesty/container/TaxAmnestyContainer';
import DiscountPenaltyContainer from './discountPenalty/container/DiscountPenaltyContainer';

function SettingsContainer({ match, pathName }) {
  const permissions = getJson('permissions');

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/bpls/settings/tag/requirements"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('bpls/settings/tag/requirements') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Requirements Tagging (E2E)
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/bpls/settings/tag/eboss-requirements"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('bpls/settings/tag/eboss-requirements') >
                    -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Requirements Tagging (E-boss)
                </Link>
              </li>
              <li className="nav-item">
                {Acl(permissions, ['VIEW BPLS ORDINANCE REVISION']) && (
                  <Link
                    to="/bpls/settings/ordinance-revision"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/ordinance-revision') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Ordinance Revision
                  </Link>
                )}
              </li>
              {Acl(permissions, ['VIEW BPLS TAX AMNESTY']) && (
                <li className="nav-item">
                  <Link
                    to="/bpls/settings/tax-amnesty"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/settings/tax-amnesty') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Tax Amnesty
                  </Link>
                </li>
              )}
              <li>
                <Link
                  to="/bpls/settings/discount-penalty"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('bpls/settings/discount-penalty') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Discount and Penalty
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/tag/requirements`} />}
          />
          <Route
            path={`${match.path}/tag/requirements`}
            component={TagRequirements}
          />
          <Route
            path={`${match.path}/tag/eboss-requirements`}
            component={TempRequirementsTagging}
          />
          {Acl(permissions, ['VIEW BPLS ORDINANCE REVISION']) && (
            <Route
              path={`${match.path}/ordinance-revision`}
              component={OrdinanceRevisionContainer}
            />
          )}
          {Acl(permissions, ['VIEW BPLS TAX AMNESTY']) && (
            <Route
              path={`${match.path}/tax-amnesty`}
              component={TaxAmnestyContainer}
            />
          )}
          <Route
            path={`${match.path}/discount-penalty`}
            component={DiscountPenaltyContainer}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SettingsContainer);
